import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useLang } from "../context/LangContext";
import { pickLang } from "../lib/i18n";
import { api } from "../lib/api";
import { ArrowLeft } from "@phosphor-icons/react";
import SEO from "../components/SEO";

export default function BlogDetail() {
  const { slug } = useParams();
  const { lang } = useLang();
  const [post, setPost] = useState(null);

  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(false)); }, [slug]);

  if (post === null) return <div className="max-w-3xl mx-auto px-5 py-32 text-gray-400">Loading...</div>;
  if (post === false) return <div className="max-w-3xl mx-auto px-5 py-32 text-gray-400">Not found. <Link to="/blog" className="link-neon">Back</Link></div>;

  const body = pickLang(post.body, lang);

  return (
    <article className="max-w-3xl mx-auto px-5 sm:px-8 py-16" data-testid="blog-detail-page">
      <SEO
        title={post.title}
        description={post.excerpt}
        image={post.cover_image}
        path={`/blog/${post.slug}`}
      />
      <Link to="/blog" className="inline-flex items-center gap-2 mono-font text-xs uppercase tracking-[0.2em] text-gray-400 hover:text-[#ccff00] mb-10">
        <ArrowLeft size={14} /> {lang === "gr" ? "Πίσω" : "Back to journal"}
      </Link>
      <div className="flex flex-wrap gap-2 mb-4">
        {(post.tags || []).map((t) => (
          <span key={t} className="mono-font text-[10px] uppercase tracking-[0.2em] text-[#ccff00] border border-[#ccff00]/40 px-2 py-1">{t}</span>
        ))}
      </div>
      <h1 className="display-font text-4xl sm:text-6xl font-black uppercase tracking-tighter leading-[0.95]">
        {pickLang(post.title, lang)}
      </h1>
      <div className="mono-font text-xs text-gray-500 mt-4">{post.author} · {new Date(post.created_at).toLocaleDateString(lang === "gr" ? "el-GR" : "en-GB")}</div>
      {post.cover_image && (
        <img src={post.cover_image} alt="" className="w-full aspect-[16/9] object-cover mt-10" />
      )}
      <div className="prose prose-invert mt-10 text-gray-200 leading-relaxed whitespace-pre-wrap" data-testid="blog-body">
        {body}
      </div>
    </article>
  );
}
